import {
  AUTOCOMPLETE_OFF,
  DynamicFormControlLayout,
  serializable,
} from '@ng-dynamic-forms/core';

import {
  DsDynamicInputModel,
  DsDynamicInputModelConfig,
} from '../ds-dynamic-input.model';

export const DYNAMIC_FORM_CONTROL_TYPE_ONEBOX = 'ONEBOX';

export interface DsDynamicOneboxModelConfig extends DsDynamicInputModelConfig {
  minChars?: number;
  value?: any;
  submissionScope?: string;
}

export class DynamicOneboxModel extends DsDynamicInputModel {

  @serializable() minChars: number;
  @serializable() readonly type: string = DYNAMIC_FORM_CONTROL_TYPE_ONEBOX;
  @serializable() submissionScope: string;

  constructor(config: DsDynamicOneboxModelConfig, layout?: DynamicFormControlLayout) {

    super(config, layout);

    this.autoComplete = AUTOCOMPLETE_OFF;
    this.minChars = config.minChars || 3;
    this.submissionScope = config.submissionScope;
  }

}
